<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const theme = computed(() => {
  const name = (props.inbox?.name || '').toLowerCase();
  const channelType = (props.inbox?.channel_type || props.inbox?.channelType || '').toLowerCase();

  // Custom color if provided in inbox
  const customColor = props.inbox?.color || props.inbox?.auto_assignment_config?.color;
  if (customColor) {
    return {
      bg: `${customColor}18`,
      border: `${customColor}50`,
      text: customColor,
      icon: customColor,
      darkText: customColor
    };
  }

  // 1. E-Mail -> Lavanda / Índigo suave
  if (channelType.includes('email') || name.includes('e-mail') || name.includes('email') || name.includes('mail')) {
    return {
      bg: 'rgba(99, 102, 241, 0.12)',
      border: 'rgba(99, 102, 241, 0.35)',
      text: '#4338ca',
      icon: '#6366f1',
      darkText: '#a5b4fc',
    };
  }

  // 2. WebWidget / Site -> Azul Céu / Ciano suave
  if (channelType.includes('webwidget') || name.includes('site') || name.includes('web')) {
    return {
      bg: 'rgba(14, 165, 233, 0.12)',
      border: 'rgba(14, 165, 233, 0.35)',
      text: '#0369a1',
      icon: '#0ea5e9',
      darkText: '#7dd3fc',
    };
  }

  // 3. WhatsApp Secundário (1481 / Meta Ads) -> Verde Petróleo / Esmeralda Elegante
  if (name.includes('1481') || name.includes('meta') || name.includes('secundario') || name.includes('anuncio')) {
    return {
      bg: 'rgba(13, 148, 136, 0.14)',
      border: 'rgba(13, 148, 136, 0.45)',
      text: '#0f766e',
      icon: '#14b8a6',
      darkText: '#2dd4bf',
    };
  }

  // 4. WhatsApp Pessoal (3389 / Pessoal) -> Âmbar / Laranja Suave
  if (name.includes('3389') || name.includes('pessoal')) {
    return {
      bg: 'rgba(245, 158, 11, 0.15)',
      border: 'rgba(245, 158, 11, 0.45)',
      text: '#b45309',
      icon: '#f59e0b',
      darkText: '#fde047',
    };
  }

  // 5. WhatsApp Principal (0940 / Fixo / Zap / Padrão) -> Verde WhatsApp Autêntico
  return {
    bg: 'rgba(22, 163, 74, 0.14)',
    border: 'rgba(22, 163, 74, 0.45)',
    text: '#15803d',
    icon: '#22c55e',
    darkText: '#4ade80',
  };
});
</script>

<template>
  <div
    :title="inbox.name"
    class="inbox-pill-tag inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10.5px] font-bold tracking-tight max-w-full overflow-hidden shrink-0 select-none shadow-2xs"
    :style="{
      backgroundColor: theme.bg,
      borderColor: theme.border,
      borderWidth: '1px',
      borderStyle: 'solid',
      color: theme.text,
      '--dark-pill-text': theme.darkText
    }"
  >
    <ChannelIcon :inbox="inbox" class="size-3.5 flex-shrink-0" :style="{ color: theme.icon }" />
    <span class="truncate leading-none">
      {{ inbox.name }}
    </span>
  </div>
</template>

<style scoped>
:global(.dark) .inbox-pill-tag {
  color: var(--dark-pill-text, inherit) !important;
}
</style>
